import React, { useState, useEffect } from 'react';
import { Link, RouteComponentProps } from 'react-router-dom';
import { Button, Row, Col, FormText } from 'reactstrap';
import { isNumber, ValidatedField, ValidatedForm } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Select from 'react-select';
import { IAidasOrganisation } from 'app/shared/model/ainnotateservice/aidas-organisation.model';
import { getEntities as getAidasOrganisations } from 'app/entities/ainnotateservice/aidas-organisation/aidas-organisation.reducer';
import { IAidasCustomer } from 'app/shared/model/ainnotateservice/aidas-customer.model';
import { getEntities as getAidasCustomers } from 'app/entities/ainnotateservice/aidas-customer/aidas-customer.reducer';
import { IAidasVendor } from 'app/shared/model/ainnotateservice/aidas-vendor.model';
import { getEntities as getAidasVendors } from 'app/entities/ainnotateservice/aidas-vendor/aidas-vendor.reducer';
import { IAidasAuthority } from 'app/shared/model/ainnotateservice/aidas-authority.model';
import { getEntities as getAidasAuthorities } from 'app/entities/ainnotateservice/aidas-authority/aidas-authority.reducer';

import { getEntity, updateEntity, createEntity, reset } from './aidas-user.reducer';
import { IAidasUser } from 'app/shared/model/ainnotateservice/aidas-user.model';
import { convertDateTimeFromServer, convertDateTimeToServer, displayDefaultDateTime } from 'app/shared/util/date-utils';
import { mapIdList } from 'app/shared/util/entity-utils';
import { useAppDispatch, useAppSelector } from 'app/config/store';



export const AidasUserUpdate = (props: RouteComponentProps<{ id: string }>) => {

  const dispatch = useAppDispatch();

  const [isNew] = useState(!props.match.params || !props.match.params.id);

  const aidasOrganisations = useAppSelector(state => state.aidasOrganisation.entities);
  const aidasCustomers = useAppSelector(state => state.aidasCustomer.entities);
  const aidasVendors = useAppSelector(state => state.aidasVendor.entities);
  const aidasAuthorities = useAppSelector(state => state.aidasAuthority.entities);
  const aidasUserEntity = useAppSelector(state => state.aidasUser.entity);
  const loading = useAppSelector(state => state.aidasUser.loading);
  const updating = useAppSelector(state => state.aidasUser.updating);
  const updateSuccess = useAppSelector(state => state.aidasUser.updateSuccess);

  const [selectedAuths,setSelectedAuths]=useState([]);
  const [roleOrgAdminSelected,setRoleOrgAdminSelected]=useState(true);
  const [roleCustomerAdminSelected,setRoleCustomerAdminSelected]=useState(true);
  const [roleVendorAdminSelected,setRoleVendorAdminSelected]=useState(true);
  const handleChange = (selectedOption) => {
    const selected=[...selectedOption];
    setSelectedAuths(selected);
    /* eslint-disable no-console */
    const orgAdmin = selectedOption.find(item=> item.name === 'ROLE_ORG_ADMIN');
    const custAdmin = selectedOption.find(item=> item.name === 'ROLE_CUSTOMER_ADMIN');
    const vendorAdmin = selectedOption.find(item=> item.name === 'ROLE_VENDOR_ADMIN');
    const vendorUser = selectedOption.find(item=> item.name === 'ROLE_VENDOR_USER');

    if(orgAdmin){
      setRoleOrgAdminSelected(false);
    }else{
      setRoleOrgAdminSelected(true);
    }

    if(custAdmin){
      setRoleCustomerAdminSelected(false);
    }else{
      setRoleCustomerAdminSelected(true);
    }

    if(vendorAdmin){
      setRoleVendorAdminSelected(false);
    }else{
      setRoleVendorAdminSelected(true);
      if(vendorUser){
        setRoleVendorAdminSelected(false);
      }else{
        setRoleVendorAdminSelected(true);
      }
    }



    /* eslint-enable no-console */

  }

  const handleClose = () => {
    props.history.push('/aidas-user' + props.location.search);
  };

  useEffect(() => {
    if (isNew) {
      dispatch(reset());
    } else {
      dispatch(getEntity(props.match.params.id));
    }

    dispatch(getAidasOrganisations({}));
    dispatch(getAidasCustomers({}));
    dispatch(getAidasVendors({}));
    dispatch(getAidasAuthorities({}));
  }, []);



  useEffect(() => {
    if (updateSuccess) {
      handleClose();
    }
  }, [updateSuccess]);


  const saveEntity = values => {
    /* eslint-disable no-console */
    console.log(selectedAuths);
    /* eslint-enable no-console */
    const entity = {
      ...aidasUserEntity,
      ...values,
      aidasOrganisation: aidasOrganisations.find(it => it.id.toString() === values.aidasOrganisationId.toString()),
      aidasCustomer: aidasCustomers.find(it => it.id.toString() === values.aidasCustomerId.toString()),
      aidasVendor: aidasVendors.find(it => it.id.toString() === values.aidasVendorId.toString()),
      aidasAuthorities: selectedAuths,
    };


    if (isNew) {
      dispatch(createEntity(entity));
    } else {
      dispatch(updateEntity(entity));
    }
  };

  const defaultValues = () =>
    isNew
      ? {}
      : {
          ...aidasUserEntity,
          aidasOrganisationId: aidasUserEntity?.aidasOrganisation?.id,
          aidasCustomerId: aidasUserEntity?.aidasCustomer?.id,
          aidasVendorId: aidasUserEntity?.aidasVendor?.id,
        };

  return (
    <div>
      <Row className="justify-content-center">
        <Col md="8">
          <h2 id="ainnotategwApp.ainnotateserviceAidasUser.home.createOrEditLabel" data-cy="AidasUserCreateUpdateHeading">
            Create or edit a AidasUser
          </h2>
        </Col>
      </Row>
      <Row className="justify-content-center">
        <Col md="8">
          {loading ? (
            <p>Loading...</p>
          ) : (
            <ValidatedForm defaultValues={defaultValues()} onSubmit={saveEntity}>
              {!isNew ? <ValidatedField name="id" required readOnly id="aidas-user-id" label="ID" validate={{ required: true }} /> : null}
              <ValidatedField
                label="Username"
                id="aidas-user-firstName"
                name="login"
                data-cy="login"
                type="text"
                validate={{
                  required: { value: true, message: 'This field is required.' },
                  minLength: { value: 3, message: 'This field is required to be at least 3 characters.' },
                  maxLength: { value: 100, message: 'This field cannot be longer than 100 characters.' },
                }}
              />
              <ValidatedField
                label="First Name"
                id="aidas-user-firstName"
                name="firstName"
                data-cy="firstName"
                type="text"
                validate={{
                  required: { value: true, message: 'This field is required.' },
                  minLength: { value: 3, message: 'This field is required to be at least 3 characters.' },
                  maxLength: { value: 100, message: 'This field cannot be longer than 100 characters.' },
                }}
              />
              <ValidatedField
                label="Last Name"
                id="aidas-user-lastName"
                name="lastName"
                data-cy="lastName"
                type="text"
                validate={{
                  minLength: { value: 3, message: 'This field is required to be at least 3 characters.' },
                  maxLength: { value: 100, message: 'This field cannot be longer than 100 characters.' },
                }}
              />
              <ValidatedField
                label="Email"
                id="aidas-user-email"
                name="email"
                data-cy="email"
                type="text"
                validate={{
                  required: { value: true, message: 'This field is required.' },
                  minLength: { value: 5, message: 'This field is required to be at least 5 characters.' },
                  maxLength: { value: 100, message: 'This field cannot be longer than 100 characters.' },
                }}
              />
              <ValidatedField label="Locked" id="aidas-user-locked" name="locked" data-cy="locked" check type="checkbox" />

              <ValidatedField
                label="Password"
                id="aidas-user-password"
                name="password"
                data-cy="password"
                type="text"
                validate={{
                  required: { value: true, message: 'This field is required.' },
                  minLength: { value: 8, message: 'This field is required to be at least 8 characters.' },
                  maxLength: { value: 20, message: 'This field cannot be longer than 20 characters.' },
                }}
              />
              <ValidatedField
                id="aidas-user-aidasOrganisation"
                name="aidasOrganisationId"
                data-cy="aidasOrganisation"
                label="Aidas Organisation"
                type="select"
                hidden={roleOrgAdminSelected}
                validate={{required: { value: !roleOrgAdminSelected, message: 'This field is required.' },}}
              >
                <option value="" key="0" />
                {aidasOrganisations
                  ? aidasOrganisations.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.name}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <ValidatedField
                id="aidas-user-aidasCustomer"
                name="aidasCustomerId"
                data-cy="aidasCustomer"
                label="Aidas Customer"
                type="select"
                hidden={roleCustomerAdminSelected}
                validate={{required: { value: !roleCustomerAdminSelected, message: 'This field is required.' },}}
              >
                <option value="" key="0" />
                {aidasCustomers
                  ? aidasCustomers.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.name}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <ValidatedField
                id="aidas-user-aidasVendor"
                name="aidasVendorId"
                data-cy="aidasVendor"
                label="Aidas Vendor"
                type="select"
                hidden={roleVendorAdminSelected}
                validate={{required: { value: !roleVendorAdminSelected, message: 'This field is required.' },}}
              >
                <option value="" key="0" />
                {aidasVendors
                  ? aidasVendors.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id} >
                        {otherEntity.name}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <Select
                defaultValue={aidasUserEntity.aidasAuthorities}
                isMulti
                name="colors"
                getOptionLabel={(option)=>option.name}
                getOptionValue={(option)=>option.name}
                options={aidasAuthorities}
                className="basic-multi-select"
                classNamePrefix="select"
                onChange={handleChange}
              />

              <Button tag={Link} id="cancel-save" data-cy="entityCreateCancelButton" to="/aidas-user" replace color="info">
                <FontAwesomeIcon icon="arrow-left" />
                &nbsp;
                <span className="d-none d-md-inline">Back</span>
              </Button>
              &nbsp;
              <Button color="primary" id="save-entity" data-cy="entityCreateSaveButton" type="submit" disabled={updating}>
                <FontAwesomeIcon icon="save" />
                &nbsp; Save
              </Button>
            </ValidatedForm>
          )}
        </Col>
      </Row>
    </div>
  );
};

export default AidasUserUpdate;
